import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../api/axiosInstance';

export const fetchMenuNavigationList = createAsyncThunk(
    'menu/fetchMenuNavigationList',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get(`/menus/hierarchy`);
            return data;
        } catch (error) {
            return rejectWithValue('Failed to fetch menu');
        }
    },
);
// Delivery partners menu
export const fetchDeliveryPartnersList = createAsyncThunk(
    'delivery-partners/fetchDeliveryPartnersList',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get(`/delivery-partners/partners`);
            return data;
        } catch (error) {
            return rejectWithValue('Failed to fetch menu');
        }
    },
);

// Get based on name
export const fetchDeliveryPartnerByShortName = createAsyncThunk(
    'delivery-partners/fetchDeliveryPartnerByShortName',
    async (shortName, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get(`/delivery-partners/partners/${shortName}`);
            return data;
        } catch (error) {
            return rejectWithValue('Failed to fetch delivery partner by short name');
        }
    },
);

// Create new delivery partner
export const createDeliveryPartner = createAsyncThunk(
    'delivery-partners/createDeliveryPartner',
    async (partnerData, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post('/delivery-partners/partners', partnerData);
            return data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || 'Failed to create delivery partner',
            );
        }
    },
);

// Update delivery partner
export const updateDeliveryPartner = createAsyncThunk(
    'delivery-partners/updateDeliveryPartner',
    async ({ id, partnerData }, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.put(`/delivery-partners/partners/${id}`, partnerData);
            return { data, id };
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || 'Failed to update delivery partner',
            );
        }
    },
);

// Update delivery partner status
export const updateDeliveryPartnerStatus = createAsyncThunk(
    'delivery-partners/updateDeliveryPartnerStatus',
    async ({ id, status }, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.put(`/delivery-partners/partners/${id}`, {
                id,
                status,
            });
            return { data, id, status };
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || 'Failed to update delivery partner status',
            );
        }
    },
);

// Delete delivery partner
export const deleteDeliveryPartner = createAsyncThunk(
    'admin/deleteDeliveryPartner',
    async (partnerId, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.delete(`/delivery-partners/partners/${partnerId}`);
            return { data, partnerId };
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || 'Failed to delete delivery partner',
            );
        }
    },
);